import { FormRoute } from '../routes/FormRoutes';
import { AwsRum } from 'aws-rum-web';

declare global {
  interface Window {
    AwsRum?: AwsRum;
  }
}

export const trackFormStep = (step: FormRoute): void => {
  if (window.AwsRum) {
    window.AwsRum.recordPageView(step);
  }
};